import { respondTo } from '@careguide/theme'
import React from 'react'
import styled from 'styled-components'
import VisuallyHidden from '@reach/visually-hidden'
import NextLink from 'next/link'

const Logo = styled(({ logoLarge, logoSmall, altTag, className }) => {
  return (
    <NextLink href='/' passHref>
      <a className={className}>
        <img id='logo-small' role='presentation' src={logoSmall} height='32px' width='32px' />
        <img id='logo-large' role='presentation' src={logoLarge} height='60px' />
        <VisuallyHidden>{altTag}</VisuallyHidden>
      </a>
    </NextLink>
  )
})`
  line-height: 0;
  display: block;
  #logo-large {
    display: none;
  }

  ${respondTo.desktop`
    #logo-small {
      display: none;
    }
    #logo-large {
      display: inline;
    }
  `}
`

export default Logo
